export default function SuccessButton({buttonText, clickHandler}) {
	return (
		<>
			<button type="button" onClick={clickHandler} className="btn btn-success m-5">
				{buttonText}
			</button>
		</>
	);
}